import React, { useState } from "react";
import { styled } from "@mui/material/styles";
import Tooltip, { TooltipProps, tooltipClasses } from "@mui/material/Tooltip";
import { AiFillInteraction } from "react-icons/ai";
import { BiHistory } from "react-icons/bi";
import { TbListDetails } from "react-icons/tb";
import { AiOutlineFile } from "react-icons/ai";
import { HiOutlineTicket } from "react-icons/hi";

import { connect } from "react-redux";
import { setcontactlist } from "../../../redux/actions/actions";
// Component
import UserDetails from "./User-Details.component";
import Interactiontab from "./user-list-child-component/Interaction-tab.component";
import Sessiontab from "./user-list-child-component/Session-tab.component";
import SmartXTab from "./user-list-child-component/SmartX-tab.component";
import Tickethistory from "./user-list-child-component/Ticket-history.component";
import FilesTab from "./user-list-child-component/Files-tab.component";
import SurveyTab from "./user-list-child-component/Survey-tab.component";
import { RiSurveyLine } from "react-icons/ri";

const mapStateToProps = (state) => {
  const { data } = state;
  return {
    showExternalChat: state.data.showExternalChat,
  };
};
const Userlist = (props) => {
  const { customerdetailshow } = props;
  let permission = JSON.parse(localStorage.getItem("permission"));
  const BootstrapTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
      color: theme.palette.common.black,
    },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: theme.palette.common.black,
    },
  }));

  const [InteractionHistory, setInteractionHistory] =
    useState("nav-link active");
  const [InteractionHistorytab, setInteractionHistorytab] = useState(
    "tab-pane fade show active"
  );
  const [SessionHistory, setSessionHistory] = useState("nav-link");
  const [SessionHistorytab, setSessionHistorytab] =
    useState("tab-pane fade show");
  const [SmartX, setSmartX] = useState("nav-link");
  const [SmartXtab, setSmartXtab] = useState("tab-pane fade show");
  const [Files, setFiles] = useState("nav-link");
  const [Filestab, setFilestab] = useState("tab-pane fade show");
  const [Ticket, setTicket] = useState("nav-link");
  const [TicketTab, setTicketTab] = useState("tab-pane fade show");

  const [sms, setSms] = useState("nav-link");
  const [smsTab, setSmsTab] = useState("tab-pane fade show");
  const [survey, setSurvey] = useState("nav-link");
  const [surveyTab, setSurveyTab] = useState("tab-pane fade show");

  const tabonchangehandler = (value) => {
    switch (value) {
      case "InteractionHistory":
        setInteractionHistory("nav-link active");
        setInteractionHistorytab("tab-pane fade show active");
        setSessionHistory("nav-link");
        setSessionHistorytab("tab-pane fade");
        setSmartX("nav-link");
        setSmartXtab("tab-pane fade");
        setFiles("nav-link");
        setFilestab("tab-pane fade");
        setTicket("nav-link");
        setTicketTab("tab-pane fade");

        setSurvey("nav-link  ");
        setSurveyTab("tab-pane fade show ");

        break;
      case "SessionHistory":
        setInteractionHistory("nav-link ");
        setInteractionHistorytab("tab-pane fade");
        setSessionHistory("nav-link active");
        setSessionHistorytab("tab-pane fade show active");
        setSmartX("nav-link");
        setSmartXtab("tab-pane fade");
        setFiles("nav-link");
        setFilestab("tab-pane fade");
        setTicket("nav-link");
        setTicketTab("tab-pane fade");

        setSurvey("nav-link  ");
        setSurveyTab("tab-pane fade show ");

        break;
      case "SmartX":
        setInteractionHistory("nav-link ");
        setInteractionHistorytab("tab-pane fade");
        setSessionHistory("nav-link");
        setSessionHistorytab("tab-pane fade");
        setSmartX("nav-link active");
        setSmartXtab("tab-pane fade show active");
        setFiles("nav-link");
        setFilestab("tab-pane fade");
        setTicket("nav-link");
        setTicketTab("tab-pane fade");

        setSurvey("nav-link  ");
        setSurveyTab("tab-pane fade show ");
        break;
      case "Files":
        setInteractionHistory("nav-link ");
        setInteractionHistorytab("tab-pane fade");
        setSessionHistory("nav-link");
        setSessionHistorytab("tab-pane fade");
        setSmartX("nav-link ");
        setSmartXtab("tab-pane fade show ");
        setFiles("nav-link active");
        setFilestab("tab-pane fade show active");
        setTicket("nav-link ");
        setTicketTab("tab-pane fade show ");

        setSurvey("nav-link  ");
        setSurveyTab("tab-pane fade show ");

        break;
      case "Ticket":
        setInteractionHistory("nav-link ");
        setInteractionHistorytab("tab-pane fade");
        setSessionHistory("nav-link");
        setSessionHistorytab("tab-pane fade");
        setSmartX("nav-link ");
        setSmartXtab("tab-pane fade show ");
        setFiles("nav-link");
        setFilestab("tab-pane fade");
        setTicket("nav-link active");
        setTicketTab("tab-pane fade show active");

        setSurvey("nav-link  ");
        setSurveyTab("tab-pane fade show ");

        break;
      case "sms":
        setInteractionHistory("nav-link ");
        setInteractionHistorytab("tab-pane fade");
        setSessionHistory("nav-link");
        setSessionHistorytab("tab-pane fade");
        setSmartX("nav-link ");
        setSmartXtab("tab-pane fade show ");
        setFiles("nav-link");
        setFilestab("tab-pane fade");
        setTicket("nav-link ");
        setTicketTab("tab-pane fade show ");

        setSurvey("nav-link ");
        setSurveyTab("tab-pane fade show ");

        break;
      case "survey":
        setInteractionHistory("nav-link ");
        setInteractionHistorytab("tab-pane fade");
        setSessionHistory("nav-link");
        setSessionHistorytab("tab-pane fade");
        setSmartX("nav-link ");
        setSmartXtab("tab-pane fade show ");
        setFiles("nav-link");
        setFilestab("tab-pane fade");
        setTicket("nav-link ");
        setTicketTab("tab-pane fade show ");
        setSurvey("nav-link active ");
        setSurveyTab("tab-pane fade show active");

        break;
      default:
        setInteractionHistory("nav-link active");
        setInteractionHistorytab("tab-pane fade show active");
        setSessionHistory("nav-link");
        setSessionHistorytab("tab-pane fade show ");
        setSmartX("nav-link");
        setSmartXtab("tab-pane fade");
        setFiles("nav-link ");
        setFilestab("tab-pane fade show ");
        setTicket("nav-link");
        setTicketTab("tab-pane fade");
        setSurvey("nav-link  ");
        setSurveyTab("tab-pane fade show ");
    }
  };

  return (
    <>
      <div
        className={customerdetailshow ? " px-0" : "col-md-4 px-0"}
        style={{ display: props.showExternalChat ? "block" : "none" }}
      >
        <div className="details-user-chat borde r-bottom p-0">
          <div className="chat-profile-userlist d-flex justify-content-between align-items-center p-2">
            <UserDetails customerdetailshow={customerdetailshow} />
          </div>
        </div>

        <div className="chat-tabs">
          <ul
            className="nav nav-pills border-bottom border-top p-2 "
            id="pills-tab"
            role="tablist"
            style={{ justifyContent: "space-around" }}
          >
            <BootstrapTooltip title="Interaction History" arrow placement="top">
              <li className="nav-item" role="presentation">
                <button
                  className={InteractionHistory}
                  id="pills-home-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-home"
                  type="button"
                  role="tab"
                  aria-controls="pills-home"
                  aria-selected="true"
                  onClick={() => {
                    tabonchangehandler("InteractionHistory");
                  }}
                  style={{ boxShadow: "1px 1px 2px gray", fontWeight: 600 }}
                >
                  <AiFillInteraction size={17} />
                </button>
              </li>
            </BootstrapTooltip>

            <BootstrapTooltip title="Session History" arrow placement="top">
              <li className="nav-item" role="presentation">
                <button
                  className={SessionHistory}
                  id="pills-home-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-home"
                  type="button"
                  role="tab"
                  aria-controls="pills-home"
                  aria-selected="true"
                  onClick={() => {
                    tabonchangehandler("SessionHistory");
                  }}
                  style={{ boxShadow: "1px 1px 2px gray", fontWeight: 600 }}
                >
                  <BiHistory size={17} />
                </button>
              </li>
            </BootstrapTooltip>

            {permission.map((module) => {
              if (module.moduleName === "Chat") {
                const value = module.screen.find(
                  (item) =>
                    item.screenId === "SMART_X" && item.read && item.write
                );
                if (value) {
                  return (
                    <>
                      {" "}
                      <BootstrapTooltip title="SmartX" arrow placement="top">
                        <li className="nav-item" role="presentation">
                          <button
                            className={SmartX}
                            id="pills-home-tab"
                            data-bs-toggle="pill"
                            data-bs-target="#pills-home"
                            type="button"
                            role="tab"
                            aria-controls="pills-home"
                            aria-selected="true"
                            onClick={() => {
                              tabonchangehandler("SmartX");
                            }}
                            style={{
                              boxShadow: "1px 1px 2px gray",
                              fontWeight: 600,
                            }}
                          >
                            <TbListDetails size={17} />
                          </button>
                        </li>
                      </BootstrapTooltip>
                    </>
                  );
                } else {
                  return <></>;
                }
              }
            })}

            {permission.map((module) => {
              if (module.moduleName === "Chat") {
                const value = module.screen.find(
                  (item) => item.screenId === "FILES" && item.read && item.write
                );
                if (value) {
                  return (
                    <BootstrapTooltip title="Files" arrow placement="top">
                      <li className="nav-item" role="presentation">
                        <button
                          className={Files}
                          id="pills-home-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#pills-home"
                          type="button"
                          role="tab"
                          aria-controls="pills-home"
                          aria-selected="true"
                          onClick={() => {
                            tabonchangehandler("Files");
                          }}
                          style={{
                            boxShadow: "1px 1px 2px gray",
                            fontWeight: 600,
                          }}
                        >
                          <AiOutlineFile size={17} />
                        </button>
                      </li>
                    </BootstrapTooltip>
                  );
                } else {
                  return <></>;
                }
              }
            })}

            {permission.map((module) => {
              if (module.moduleName === "Chat") {
                const value = module.screen.find(
                  (item) =>
                    item.screenId === "TICKET" && item.read && item.write
                );
                if (value) {
                  return (
                    <BootstrapTooltip title="Ticket" arrow placement="top">
                      <li className="nav-item" role="presentation">
                        <button
                          className={Ticket}
                          id="pills-home-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#pills-home"
                          type="button"
                          role="tab"
                          aria-controls="pills-home"
                          aria-selected="true"
                          onClick={() => {
                            tabonchangehandler("Ticket");
                          }}
                          style={{
                            boxShadow: "1px 1px 2px gray",
                            fontWeight: 600,
                          }}
                        >
                          <HiOutlineTicket size={17} />
                        </button>
                      </li>
                    </BootstrapTooltip>
                  );
                } else {
                  return <></>;
                }
              }
            })}

            {permission.map((module) => {
              if (module.moduleName === "Chat") {
                const value = module.screen.find(
                  (item) =>
                    item.screenId === "SURVEY" && item.read && item.write
                );
                if (value) {
                  return (
                    <BootstrapTooltip title="Survey" arrow placement="top">
                      <li className="nav-item" role="presentation">
                        <button
                          className={survey}
                          id="pills-home-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#pills-home"
                          type="button"
                          role="tab"
                          aria-controls="pills-home"
                          aria-selected="true"
                          onClick={() => {
                            tabonchangehandler("survey");
                          }}
                          style={{
                            boxShadow: "1px 1px 2px gray",
                            fontWeight: 600,
                          }}
                        >
                          <RiSurveyLine size={17} />
                        </button>
                      </li>
                    </BootstrapTooltip>
                  );
                } else {
                  return <></>;
                }
              }
            })}
          </ul>

          <div className="tab-content" id="pills-tabContent">
            <Interactiontab InteractionHistorytab={InteractionHistorytab} />
            <Sessiontab SessionHistorytab={SessionHistorytab} />
            <SmartXTab SmartXTab={SmartXtab} />
            <FilesTab FilesTab={Filestab} />
            <Tickethistory TicketTab={TicketTab} />
            <SurveyTab surveyTab={surveyTab} />
          </div>
        </div>
      </div>
    </>
  );
};

export default connect(mapStateToProps, {
  setcontactlist,
})(Userlist);
